export default __webpack_public_path__ + "static/media/list-with-a-tick-icon.422f07f5.svg";